/**
 * Agrégats packs pour rapports — re-groupement uniquement, jamais un 2ᵉ CA.
 * CA pack = somme des finalPrice des lignes (pas packPrice).
 */

export type PackSaleLineLike = {
  packId?: string;
  packInstanceId?: string;
  packName?: string;
  packPrice?: number;
  soldAsPack?: boolean;
  finalPrice?: number;
};

export type PackInstanceKpi = {
  packInstanceId: string;
  packId?: string;
  packName?: string;
  /** Somme des lignes — source de vérité CA. */
  revenue: number;
  lineCount: number;
  packPrice?: number;
};

export function aggregatePackInstanceKpis(
  lines: PackSaleLineLike[]
): PackInstanceKpi[] {
  const byInstance = new Map<string, PackInstanceKpi>();

  for (const line of lines) {
    if (!line.soldAsPack || !line.packInstanceId) continue;
    const id = line.packInstanceId;
    const existing = byInstance.get(id);
    const amount = Math.max(0, Math.floor(Number(line.finalPrice) || 0));
    if (!existing) {
      byInstance.set(id, {
        packInstanceId: id,
        packId: line.packId,
        packName: line.packName,
        revenue: amount,
        lineCount: 1,
        packPrice: line.packPrice,
      });
    } else {
      existing.revenue += amount;
      existing.lineCount += 1;
    }
  }

  return Array.from(byInstance.values());
}

/** Nombre d'instances pack distinctes (KPI volume, pas CA). */
export function countPackInstancesSold(lines: PackSaleLineLike[]): number {
  return aggregatePackInstanceKpis(lines).length;
}

/**
 * Montant à créditer à stats.revenueGenerated marketing.
 * Pack : une seule fois (composant index 0) via packPrice / sinon finalPrice ligne.
 */
export function marketingRevenueForPackAwareLine(line: {
  soldAsPack?: boolean;
  packComponentIndex?: number;
  packPrice?: number;
  finalPrice?: number;
  price?: number;
}): number {
  const lineAmount = Math.max(
    0,
    Math.floor(Number(line.finalPrice ?? line.price) || 0)
  );
  if (!line.soldAsPack) return lineAmount;
  if ((line.packComponentIndex ?? 0) !== 0) return 0;
  const packPrice = Math.floor(Number(line.packPrice) || 0);
  return packPrice > 0 ? packPrice : lineAmount;
}

/** Appliquer la promo marketing seulement sur la 1ʳᵉ ligne du pack (ou hors pack). */
export function shouldApplyMarketingPromotionForLine(line: {
  soldAsPack?: boolean;
  packComponentIndex?: number;
}): boolean {
  if (!line.soldAsPack) return true;
  return (line.packComponentIndex ?? 0) === 0;
}
